import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeModule } from '../home/home.module';
import { ReportFrameworkRoutingModule } from './report-framework-routing.module';
import { ReportCreateComponent } from './report-create/report-create.component';
import { DistributionCreateComponent } from './distribution-create/distribution-create.component';
import { ReportDetailsComponent } from './report-details/report-details.component';
import { ReportViewComponent } from './report-view/report-view.component';
import { ReportProcessComponent } from './report-process/report-process.component';
import { AddDistributionComponent } from './add-distribution/add-distribution.component';

@NgModule({
  declarations: [
    ReportCreateComponent,
    DistributionCreateComponent,
    ReportProcessComponent,
    ReportDetailsComponent,
    ReportViewComponent,
    AddDistributionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    HomeModule,
    ReportFrameworkRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ReportFrameworkModule { }
